import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLibrary: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLibrary"><Path fillRule="evenodd" clipRule="evenodd" d="M14.5785 2.95947L21.2905 20.5784L19.4215 21.2904L12.7095 3.67146L14.5785 2.95947ZM5 2.99996V21H3V2.99996H5ZM10 2.99996V21H8V2.99996H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLibrary;
